import { Box } from '@mui/material';
import TireProfileHandler from 'handlers/tire-pressure';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'store/hook';
import { extractReason } from 'views/TirePressure/util';
import { SWToolTip } from 'components/SWToolTip';
import { useTranslation } from 'react-i18next';

export const TirePressureNotificationCounter = () => {
  const { t } = useTranslation();
  const tireProfileHandler = new TireProfileHandler();

  const accessToken = useAppSelector((state) => state.authReducer.accessToken);
  const notifications = useAppSelector(
    (state) => state.tireProfileReducer.dashboard?.notifications
  );

  const activeNotifications = React.useMemo(() => {
    return notifications?.filter((el: any) => {
      return (
        el?.alertEndTs === null &&
        extractReason(el?.rule?.ruleName) !== 'inflate'
      );
    });
  }, [notifications]);

  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate('/tire-analytics/notification', {
      state: {
        notificationStatus: 'active',
      },
    });
  };

  //  Call API on mount and every 60 seconds
  React.useEffect(() => {
    if (!accessToken) return;

    const fetchNotifications = () => {
      void tireProfileHandler.getNotifications();
    };

    fetchNotifications(); // initial call

    const intervalId = setInterval(fetchNotifications, 60 * 1000); // call every 1 minute

    return () => {
      clearInterval(intervalId); // cleanup on unmount
    };
  }, [accessToken]);

  return (
    <SWToolTip title={t('active_tire_notifications')}>
      <button className="notification-btn" onClick={handleRedirect}>
        <Box height={'20px'} width={'20px'}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
            {/* Main Tire and Rim Group */}
            <g>
              {/* Tire Tread */}
              <circle
                cx="50"
                cy="50"
                r="45"
                fill="#FFFFFF"
                stroke="#2D3748"
                strokeWidth="2"
              />

              {/* Tread Marks */}
              <g fill="#E2E8F0">
                <rect x="46" y="0" width="8" height="12" rx="2" />
                <rect x="46" y="88" width="8" height="12" rx="2" />
                <rect x="0" y="46" width="12" height="8" rx="2" />
                <rect x="88" y="46" width="12" height="8" rx="2" />
                <g transform="rotate(45 50 50)">
                  <rect x="46" y="0" width="8" height="12" rx="2" />
                  <rect x="46" y="88" width="8" height="12" rx="2" />
                  <rect x="0" y="46" width="12" height="8" rx="2" />
                  <rect x="88" y="46" width="12" height="8" rx="2" />
                </g>
              </g>

              {/* Rim */}
              <circle cx="50" cy="50" r="34" fill="#FFFFFF" />
              <circle
                cx="50"
                cy="50"
                r="34"
                stroke="#2D3748"
                strokeWidth="4"
                fill="none"
              />

              {/* Spokes */}
              <g stroke="#2D3748" strokeWidth="5" strokeLinecap="round">
                <line x1="50" y1="50" x2="84" y2="50" />
                <line x1="50" y1="50" x2="16" y2="50" />
                <line x1="50" y1="50" x2="50" y2="16" />
                <line x1="50" y1="50" x2="50" y2="84" />
                <line x1="50" y1="50" x2="74" y2="26" />
                <line x1="50" y1="50" x2="26" y2="74" />
                <line x1="50" y1="50" x2="26" y2="26" />
                <line x1="50" y1="50" x2="74" y2="74" />
              </g>

              {/* Center Hub */}
              <circle cx="50" cy="50" r="8" fill="#FFFFFF" />
              <circle
                cx="50"
                cy="50"
                r="8"
                stroke="#2D3748"
                strokeWidth="2"
                fill="none"
              />
              <circle
                cx="50"
                cy="50"
                r="4"
                fill="#FFFFFF"
                stroke="#2D3748"
                strokeWidth="1.5"
              />
            </g>
          </svg>
        </Box>
        {activeNotifications?.length > 0 && (
          <span className="notification-badge">
            {activeNotifications?.length}
          </span>
        )}
      </button>
    </SWToolTip>
  );
};
